module.exports = __webpack_public_path__ + "static/media/1 25 dysleksi.8b59b2a5.mp3";